import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import Sidebar from './Sidebar';
import Header from './Header';
import StatusBar from './StatusBar';
import DemoMode from './DemoMode';
import DesignPartnerModal from './DesignPartnerModal';
import DataSecurityModal from './DataSecurityModal';
import PageTransition from './PageTransition';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Toaster } from '@/components/ui/sonner';

const COLLAPSE_KEY = 'apex-lens-sidebar-collapsed';

export default function APEXShell() {
  const { sidebarOpen, setSidebarOpen } = useApp();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false;
    try { return window.localStorage.getItem(COLLAPSE_KEY) === '1'; } catch { return false; }
  });

  useEffect(() => {
    try { window.localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0'); } catch { /* ignore */ }
  }, [collapsed]);

  // Reset scroll on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-apex-canvas">
      <div className="flex flex-1">
        <Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed((c) => !c)} />
        {/* Mobile drawer */}
        <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <SheetContent side="left" className="p-0 w-[280px] bg-apex-shell border-slate-800">
            <Sidebar mobile />
          </SheetContent>
        </Sheet>

        <div className="flex-1 flex flex-col min-w-0">
          <Header />
          <main className="flex-1 px-3 sm:px-4 lg:px-6 py-4 sm:py-6 lg:py-8">
            <PageTransition key={location.pathname}>
              <Outlet />
            </PageTransition>
          </main>
          <StatusBar />
        </div>
      </div>

      <DemoMode />
      <DesignPartnerModal />
      <DataSecurityModal />
      <Toaster richColors position="top-right" />
    </div>
  );
}
